import { render, staticRenderFns } from "./crm-coming.vue?vue&type=template&id=bdac55bc&"
import script from "./crm-coming.vue?vue&type=script&lang=js&"
export * from "./crm-coming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports